export const log = (message, value) =>
	console.log(
		`%c ${message} %c ${value} `,
		"background-color: #6644ff; color: white; font-weight: 500;",
		"background-color: #ff5081; color: white; font-weight: 700;"
	);

export default log;
